<template>
  <div class="control-wrap">
    <div>
      <div class="label">{{ tag.description }}</div>
      <draggable
        v-model="formItems"
        handle=".drag-handle"
        class="d-flex flex-wrap pa-2"
      >
        <image-gallery-editor-item
          v-for="(item, index) in formItems"
          :key="index"
          v-model="formItems[index]"
          :readonly="readonly"
          @on-close-click="onCloseClick(index)"
        />
      </draggable>
      <div class="d-flex pb-4 px-4">
        <v-btn depressed outlined class="mr-4" @click="addImages"
          >Добавить загруженные</v-btn
        >
        <uploader-button
          btn-title="Загрузить новые"
          :work-dir="workDir"
          multiple
          @upload-success="onUploadSuccess"
          @upload-error="onUploadError"
        />
      </div>
      <file-manager-dialog
        v-model="fmDialog"
        selected-path=""
        src="texteditor"
        :work-dir="workDir"
        :allowed-extensions="['jpg', 'jpeg', 'png', 'svg', 'gif']"
        multiple
        @fm-select="fmSelect"
        @fm-close="fmClose"
      />
    </div>
  </div>
</template>

<script>
import { computed } from "vue";
import FileManagerDialog from "./FileManagerDialog/FileManagerDialog.vue";
import UploaderButton from "@/components/UploaderButton.vue";
import ImageGalleryEditorItem from "./ImageGalleryEditorItem.vue";
import Draggable from "vuedraggable";

export default {
  components: {
    FileManagerDialog,
    UploaderButton,
    ImageGalleryEditorItem,
    Draggable
  },
  props: {
    value: {
      type: Object,
      default: () => ({ items: [] })
    },
    tag: {
      type: Object,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      fmDialog: false
    };
  },
  computed: {
    storagePrefix() {
      return this.$store.getters.getStoragePrefix;
    },
    workDir() {
      return this.tag?.custom_settings?.images_dir || "/images";
    }
  },
  methods: {
    addImages() {
      this.fmDialog = true;
    },
    fmClose() {
      this.fmDialog = false;
    },
    fmSelect(files) {
      this.fmDialog = false;
      this.addFilesToGallery(files);
    },
    addFilesToGallery(files) {
      files.forEach(file => {
        let src = file;
        if (!src.startsWith("/")) src = `/${src}`;

        const data = {
          i_main: `<STORAGE>${src}`,
          i_contain: "1",
          i_fill: this.$store.getters.getDefaultBackground,
          position: "50% 50%"
        };

        this.formItems.push(data);
      });
    },
    onUploadSuccess(files) {
      this.addFilesToGallery(files);
    },
    onUploadError(error) {
      this.$store.commit("addNotice", {
        type: "error",
        message: error
      });
    },
    onCloseClick(index) {
      this.formItems.splice(index, 1);
    }
  },
  setup(props, { emit }) {
    const formItems = computed({
      get: () => props.value.items || [],
      set: val => emit("input", { items: val })
    });

    return {
      formItems
    };
  }
};
</script>
<style scoped lang="scss">
.control-wrap {
  border: 1px solid rgba(46, 50, 58, 0.4) !important;
  border-radius: 4px;
  margin-bottom: 16px !important;
  position: relative;

  .label {
    position: absolute;
    transform-origin: top left;
    top: -10px;
    left: 9px;
    font-size: 12px;
    color: rgba(46, 50, 58, 0.54);
    background-color: #fff;
    padding: 0 2px 0 3px;
  }
}
</style>
